var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.item[_vm.props.field.key])?_c('a',{staticClass:"ds-link",attrs:{"href":_vm.props.item[_vm.props.field.key],"target":"_blank"}},[_c('icon',{attrs:{"name":'picture_as_'+_vm.props.field.key,"size":"xl"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }